import { lazy } from 'react';
import { TenantRouteMeta } from '../types';

const PublishPage = lazy(() => import('../../pages/Publish/PublishPage'));
const UserGuide = lazy(() => import('../../pages/UserGuide/UserGuide'));

/**
 * Publish + help pages. These are navigation targets reachable from the
 * top bar (Publish / Help buttons), not sidebar entries — so they carry
 * route metadata without `sidebar`.
 */
export const workflowRoutes: TenantRouteMeta[] = [
  {
    path: 'publish',
    element: <PublishPage />,
    // `publisher` was never enforced (RequireRole's ENFORCED_ROLES excludes
    // it), so today this is public — matches `publish`'s LEGACY_SHIM (always
    // true). Under RBAC_V2, `publish` is a real 16th grantable permission
    // (decisions §30), seeded broadly at cutover (§31) — layered on top of
    // tenant write access + the env fence, which still apply independently.
    role: 'publisher',
    permission: 'publish',
  },
  {
    path: 'guide',
    element: <UserGuide />,
    // Intentionally ungated — a help page every authenticated user can reach.
  },
];
